import { Flex, type FlexProps } from '@mantine/core'

import { type CoreProduct } from '@flecto/types'
import { AvatarProductsGroup } from '@flecto/ui'

type CellItemsProps = FlexProps & {
  products: CoreProduct[]
}

export function CellItems({ products = [], ...props }: CellItemsProps) {
  return (
    <Flex {...props} gap='xs' justify='flex-start'>
      <AvatarProductsGroup products={products} />
    </Flex>
  )
}
